import { cx } from "../cx";

export interface StatBarProps {
  label: string;
  /** 0..100 */
  value: number;
  /** Baseline to compare against (live loadout preview): the difference is drawn teal (gain) or red (loss). */
  compare?: number;
  class?: string;
}

/** Horizontal 0..100 stat bar with an optional comparison overlay. */
export function StatBar({ label, value, compare, class: cls }: StatBarProps) {
  const v = Math.min(100, Math.max(0, value));
  const c = compare === undefined ? v : Math.min(100, Math.max(0, compare));
  const base = Math.min(v, c);
  return (
    <div
      class={cx("statbar", cls)}
      role="meter"
      aria-label={label}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={Math.round(v)}
    >
      <span class="statbar__label">{label}</span>
      <span class="statbar__track">
        <span class="statbar__fill" style={{ width: `${base}%` }} />
        {v > c && <span class="statbar__gain" style={{ left: `${base}%`, width: `${v - c}%` }} />}
        {v < c && <span class="statbar__loss" style={{ left: `${v}%`, width: `${c - v}%` }} />}
      </span>
      <span class="statbar__value">{Math.round(v)}</span>
    </div>
  );
}
